import axios from "axios";

const getDefaultState = () => {
  return {
    establishments: [],
    selectedEstablishment: {},
    newEstablishment: false,

    services: [],
    selectedService: {},
    newService: false,
  };
};

export default {
  state: getDefaultState(),

  getters: {
    getEstablishments: (state) => state.establishments,
    getSelectedEstablishment: (state) => state.selectedEstablishment,
    getServices: (state) => state.services,
    getSelectedService: (state) => state.selectedService,
    newService: (state) => state.newService,
    getNewEstablishment: (state) => state.newEstablishment,
  },

  actions: {
    async fetchEstablishments(ctx, payload) {
      const client_name = ctx.getters.getClientName;
      const context_key = ctx.getters.getContextKey;
      const { name, zipCode, returnOnly } = payload;

      try {
        const resp = await axios.get(
          `/${client_name}/${context_key}/organizations?name=${name}&zip_code=${zipCode}`
        );
        if (!returnOnly) {
          ctx.commit("MUTATE_ESTABLISHMENTS_LIST", resp.data);
        }
        return resp.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },

    async fetchServices(ctx, establishment) {
      const client_name = ctx.getters.getClientName;
      const context_key = ctx.getters.getContextKey;

      const ID = establishment.id;

      ctx.commit("UPDATE_SELECTED_ESTABLISHMENT", {
        establishment: establishment,
        newEstablishment: false,
      });
      try {
        const resp = await axios.get(
          `/${client_name}/${context_key}/organizations/services?organization_id=${ID}`
        );
        ctx.commit("MUTATE_SERVICES_LIST", resp.data);
        return resp.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },

    async UPDATE_SELECTED_SERVICE(ctx, data) {
      await ctx.commit("UPDATE_SELECTED_SERVICE", data);
    },

    async CLEAR_ESTABLISHEMENT(ctx) {
      await ctx.commit("CLEAR_ESTABLISHEMENT");
    },
    async UPDATE_SELECTED_ESTABLISHMENT(ctx, data) {
      await ctx.commit("UPDATE_SELECTED_ESTABLISHMENT", data);
    },
  },

  mutations: {
    RESET_ESTABLISHMENTS_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    MUTATE_ESTABLISHMENTS_LIST: (state, data) => {
      state.establishments = data;
    },
    MUTATE_SERVICES_LIST: (state, data) => {
      state.services = data;
    },
    UPDATE_SELECTED_ESTABLISHMENT: (state, payload) => {
      console.log("UPDATE_SELECTED_ESTABLISHMENT", payload);
      state.selectedEstablishment = payload.establishment;
      state.newEstablishment = payload.newEstablishment;
    },
    UPDATE_SELECTED_SERVICE: (state, payload) => {
      console.log("UPDATE_SELECTED_SERVICE", payload);
      state.selectedService = payload.service;
      state.newService = payload.newService;
    },
    CLEAR_ESTABLISHEMENT: (state) => {
      state.selectedEstablishment = {};
      state.selectedService = {};
      state.newEstablishment = true;
      state.newService = true;
    },
  },
};
